"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = spaceClasses;
var _classnames = _interopRequireDefault(require("classnames"));
var _options = _interopRequireDefault(require("./options"));
const UX_SPACE_CLASSNAME = 'ux-space';

/**
 * Creates a collection of attributes for spacing styles
 *
 * @param {Object} props - A props configuration object
 * @param {String} props.as - Determines what kind of space to apply
 * @param {String} [props.className] - A class name to include
 * @param {Boolean} [props.inline] - Include space in the horizontal direction
 * @param {Boolean} [props.block] - Include space in the vertical direction
 * @param {Boolean} [props.gap] - Include space in between child elements
 * @returns {String} A collection of classnames
 */
function spaceClasses(props) {
  const {
    as,
    className,
    inline,
    block,
    gap
  } = props || {};
  return (0, _classnames.default)(UX_SPACE_CLASSNAME, className, {
    [`${UX_SPACE_CLASSNAME}--as-${as}`]: Object.values(_options.default).includes(as),
    [`${UX_SPACE_CLASSNAME}--inline`]: inline,
    [`${UX_SPACE_CLASSNAME}--block`]: block,
    [`${UX_SPACE_CLASSNAME}--gap`]: gap
  });
}